module.exports = __webpack_public_path__ + "img/sbzc_14.2f68b9ef.jpg";